import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRenditionMonitor extends Layout {
    buttonLoadJob: Button;
    horizontalspacer1: HorizontalSpacer;
    labelHeader: Label;
    layoutEmail: Layout;
    layoutFTP: Layout;
    layoutFax: Layout;
    layoutLGX: Layout;
    layoutPrint: Layout;
    layoutTotal: Layout;
    panelHeader: Panel;
    panelHideShow: Panel;
    panelTotalContainer: Panel;
    sourceRenditionBilling: DataSource;
    switchShowAll: Switch;
    switchShowEmail: Switch;
    switchShowFTP: Switch;
    switchShowFax: Switch;
    switchShowLGX: Switch;
    switchShowPrint: Switch;
    textSummary: Textbox;
    textboxJobNumber: Textbox;
    textboxRenbBillgendt: Textbox;
}
